import { useReportMessageTextQuery } from "../../../../hooks/useOrders"
import Loader from "../../../../components/Loader"
import cn from "../../../../utils/cn"
import ApiError from "../../../../components/ApiError"
import CopyIcon from "../../../../components/CopyIcon"

const ReportMessageText = ({ reportDetail, onClose }) => {
  const {
    data: message,
    isPending,
    isError,
    error,
  } = useReportMessageTextQuery({
    InboundMessageId: reportDetail.InboundMessageId ?? null,
    InboundMessageTextId: reportDetail.InboundMessageTextId ?? null,
  })

  return (
    <section className="flex flex-col">
      <div className="flex items-center justify-between border-b pb-3 mb-4">
        <div className="flex gap-1.5 justify-center items-center">
          <p className="text-xl font-bold">Report Message Text</p>
          {message?.MessageText && <CopyIcon value={message?.MessageText} />}
        </div>
        <span className="material-icons cursor-pointer" onClick={onClose}>
          close
        </span>
      </div>
      {isPending ? (
        <div className="flex items-center justify-center gap-4 mt-3">
          <Loader />
          Loading...
        </div>
      ) : isError ? (
        <div className="py-2">
          <ApiError axiosError={error} />
        </div>
      ) : (
        <div className="max-h-[80vh] overflow-y-auto pr-3">
          <p
            className={cn(
              "whitespace-pre-wrap break-all",
              !message?.MessageText && "text-center p-2"
            )}
          >
            {message?.MessageText ?? "No message text found."}
          </p>
        </div>
      )}
    </section>
  )
}

export default ReportMessageText
